var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ImagesControl", {
        attrs: { images: _vm.slide.settings.images },
        on: { subcommand: _vm.subcommand }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }